/**
 * SIM-1724 — bottom save bar for the Skills tab atomic-save UX: one shared Reason input and a Save
 * button, disabled until there is at least one staged change AND a non-empty trimmed reason. One
 * reason yields one coherent revision set across the whole batch.
 */
import { Button, Input, Label } from "@simplicity/ui";

interface SkillsSaveBarProps {
  reason: string;
  onReasonChange: (value: string) => void;
  hasChanges: boolean;
  pending: boolean;
  onSave: () => void;
}

export function SkillsSaveBar({
  reason,
  onReasonChange,
  hasChanges,
  pending,
  onSave,
}: SkillsSaveBarProps) {
  const canSave = hasChanges && reason.trim().length > 0 && !pending;
  return (
    <div className="sticky bottom-0 flex items-end gap-3 border-t border-border bg-background py-3">
      <div className="flex-1 space-y-1">
        <Label htmlFor="skills-save-reason">Reason</Label>
        <Input
          id="skills-save-reason"
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          placeholder="Why are you making these changes?"
        />
      </div>
      <Button onClick={onSave} disabled={!canSave}>
        {pending ? "Saving…" : "Save"}
      </Button>
    </div>
  );
}
